import React from "react";

const CategoryShimmer = () => {
  return (
    <div className="flex gap-5">
      <p className="w-44 h-48 bg-lightGray animate-pulse"></p>
      <p className="w-44 h-48 bg-lightGray animate-pulse"></p>
      <p className="w-44 h-48 bg-lightGray animate-pulse"></p>
      <p className="w-44 h-48 bg-lightGray animate-pulse"></p>
    </div>
  );
};

export default CategoryShimmer;
